<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<egranty-input-field-popup
			:is-open.sync="addCommitteeVisible"
			:label="'Nazwa komisji'"
			:title="'Utwórz komisję'"
			@save="addCommittee"
			@cancel="addCommitteeVisible = false"
		></egranty-input-field-popup>

		<v-dialog v-model="editCommitteeVisible" max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline"> Edycja podkomisji </span>
				</v-card-title>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap row>
							<v-flex xs12 sm6 md12>
								<v-text-field
									browser-autocomplete="off"
									v-model="editedItem.name"
									aria-label="name"
									name="name"
									label="Nazwa"
									for="commitees-view-name"
									id="commitees-view-name">
								</v-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap row>
							<v-flex xs12 sm6 md12>
								<v-autocomplete
									v-model="editedItem.countries"
									:items="editedItem.availableCountries"
									item-text="name"
									item-value="id"
									label="Kraje"
									aria-label="committee country"
									for="commitees-view-available-countries"
									id="commitees-view-available-countries"
									clearable
									multiple
									chips
									deletable-chips
								></v-autocomplete>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" @click="editFinished">Zapisz</v-btn>
					<v-btn color="blue" @click="closeEditCommittee">Anuluj</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<egranty-table class="mt-4"
			:table-name="'Komisje'"
			:headers="headers"
			:items="committees"
			:toolbar-action-name="'Dodaj komisję'"
			:row-actions="actions"
			:hide-pagination="true"
			@toolbarAction="openAddCommittee"
			@editCommittee="editCommittee"
			@deleteCommittee="deleteCommittee"
		></egranty-table>

		<egranty-autocomplete
			:is-visible="addCommitteeUserVisible"
			:headers="userHeaders"
			:possibilities="possibilities"
			title="Dodaj nową osobę do komisji"
			hint=""
			search-field-label="Osoba"
			@cancel="endAddingUsers"
			@save="addCommitteeUser"
		></egranty-autocomplete>

		<v-card>
			<v-toolbar color="blue">
				<v-toolbar-title>Składy komisji</v-toolbar-title>
			</v-toolbar>
			<v-expansion-panel>
				<v-expansion-panel-content v-for="(item,i) in committees" :key="item.name">
					<template v-slot:header>
						<div>{{item.name}}</div>
					</template>
					<egranty-table
						:table-name="'Skład'"
						:toolbar-action-name="'Dodaj osobę'"
						:headers="usersTableHeaders"
						:items="committeeUsers[i]"
						:row-actions="actionsUsers"
						@deleteUser="(item)=>{deleteUser(item.id)}"
						@toolbarAction="openAddCommitteeUser(item)"
						@promote="(item) => {promoteToLeader(item);}"
					></egranty-table>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-card>

	</div>
</template>

<script>
	import EgrantyTable from "../../../genericComponents/EgrantyTable";
	import EgrantyInputFieldPopup from "../../../genericComponents/EgrantyInputFieldPopup";
	import EgrantyAutocomplete from "../../../genericComponents/EgrantyAutocomplete";
	import {Committee} from "../../../api/generated/Committee";
	import {CommitteeUsers} from "../../../api/generated/CommitteeUsers";
	import {Api} from "../../../api";
	import {PublicContest} from "@/api/generated/PublicContest";


	export default {
		name: "CommitteesView",
		components: {EgrantyAutocomplete, EgrantyInputFieldPopup, EgrantyTable},

		methods: {

			openAddCommittee() {
				this.addCommitteeVisible = true;
			},

			openAddCommitteeUser(item) {
				this.editedItem = item;

				CommitteeUsers.getUsersToAdd(
					this,
					item.id,
					response => {
						this.addCommitteeUserVisible = true;
						this.possibilities = response;
					});
			},

			promoteToLeader(item) {
				CommitteeUsers.postPromoteToLeader(
					this,
					item.id,
					() => {
						this.refresh();
					},
				);
			},

			addCommittee(name) {
				Committee.postCommittee(
					this,
					this.$route.params.id,
					name,
					() => {
						this.addCommitteeVisible = false;
						this.refresh();
					},
				);
			},

			addCommitteeUser(item) {
				CommitteeUsers.putUser(
					this,
					this.editedItem.id,
					item.userId,
					() => {
						this.addCommitteeUserVisible = false;
						this.refresh();
					},
				);

			},

			endAddingUsers() {
				this.addCommitteeUserVisible = false;
			},

			deleteCommittee(item) {
				this.$confirm("Czy na pewno chcesz usunąć komisję?", {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie komisji",
					width: 500
				})
					.then(result => {
						if((this.contestInfo.evaluationOpen == true || this.contestInfo.contestStatus=='INITIAL_REJECTION_AND_COMMITTEE_ASSIGN') && this.committees.length == 1){
							this.$messagesBus.$emit("error", "Nie można usunąć ostatniej komisji, gdy rozpoczęto wstępne odrzucenie i przydział do komisji");
							return;
						}
						if (result) {
							Committee.deleteCommittee(this, item.id, successResponse => {
								this.$messagesBus.$emit("success", "Komisja została pomyślnie usunięta", successResponse);
								this.refresh();
							}, errorResponse => {
								this.$messagesBus.$emit("error", "Nie udało się usunąć komisji. Nie można tego zrobić jeśli przypisano do niej jakikolwiek kraj. Sprawdź też, czy nie przydzielono do niej ofert do zaopiniowania.", errorResponse);
							});
						}
					});
			},

			deleteUser(committeeUserId) {
				this.$confirm("Czy na pewno chcesz usunąć członka komisji?", {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie członka komisji",
					width: 500
				})
					.then(result => {
						if (result) {
							CommitteeUsers.deleteUser(this, committeeUserId, successResponse => {
								this.$messagesBus.$emit("success", "Członek komisji został pomyślnie usunięty", successResponse);
								this.refresh();
							}, errorResponse => {
								this.$messagesBus.$emit("error", "Nie udało się usunąć członka komisji. " +
									"Sprawdź czy nie ma przydzielonych opinii lub nie jest przewodniczącym komisji " +
								"albo osobą protokołującą w jednej z opinii końcowych.", errorResponse);
							});
						}
					});
			},

			editCommittee(item) {
				this.nameBeforeEdition = item.name;
				this.editedItem = item;
				this.editedIndex = this.committees.indexOf(item);
				this.editCommitteeVisible = true;
			},

			getCountryIdList(item) {
				if (typeof (item.countries[0]) === "number") {
					let list = [];
					item.countries.forEach(id => {
						list.push(id);
					});
					return list;
				} else {
					return item.countries.map(country => country.id);
				}
			},

			editFinished() {
				let countryIds = this.getCountryIdList(this.editedItem);

				Committee.putCommittee(
					this,
					this.editedItem.id,
					this.editedItem.name,
					countryIds,
					() => {
						this.editCommitteeVisible = false;
						this.refresh();
					},
					null);
				this.editedIndex = -1;
				this.editedItem = {};
				this.nameBeforeEdition = "";
			},

			closeEditCommittee() {
				this.editedIndex = -1;
				this.editedItem = {};
				this.editCommitteeVisible = false;
			},

			async refresh() {
				this.committeeUsers = [];
				await Api.syncGet(this,
					"/committee/all-committees"
						+ "?contestId=" + this.$route.params.id, async response => {
							this.committees = response;
							for (const committee of this.committees) {
                committee.countries.sort((a, b) => a.name.localeCompare(b.name));
                committee.availableCountries.sort((a, b) => a.name.localeCompare(b.name));
								await Api.syncGet(this, "/committee-users/users?committeeId=" + committee.id, response => {
									this.committeeUsers.push(response);
								});
							}
						});
			},
		},

		mounted() {
			this.refresh();
			PublicContest.getStatus(this, this.$route.params.id, response => {
				this.contestInfo = response;
			});
		},

		data() {
			return {
				headers: [
					{
						text: "Nazwa podkomisji",
						value: "name",
						sortable: false,
					},
					{
						text: "Kraje",
						value: "countryNames",
						sortable: false,
						postProcessor: function (item) {
							let result = item.countries.map(country => country.name);
							return Object.values(result).join(", ");
						},
					},
				],

				usersTableHeaders: [
					{text: "Imię", value: "name", sortable: false},
					{text: "Nazwisko", value: "surname", sortable: false},
					{text: "E-mail", value: "email", sortable: false},
					{
						text: "Rola w komisji",
						value: "leaderCaption",
						sortable: false,
						postProcessor: function (item) {
							return item.leader === true ? "Przewodniczący komisji" : "-";
						},
					},
				],

				userHeaders: {
					name: "Imię",
					surname: "Nazwisko",
					email: "E-mail",
					role: "Rola",
				},

				committees: [],

				committeeUsers: [],

				accreditationCountries: [],

				possibilities: [],

				editedItem: {},

				editedIndex: -1,

				addCommitteeUserVisible: false,

				addCommitteeVisible: false,

				editCommitteeVisible: false,

				nameBeforeEdition: "",

				actions: [
					{name: "editCommittee", icon: "edit"},
					{name: "deleteCommittee", icon: "delete"},
				],

				actionsUsers: [
					{
						name: "promote",
						icon: "supervisor_account",
						label: "Wyznacz na przewodniczącego",
						isDisabled: function (item) {
							return item.leader || !(item.contestRole === 'SECRETARY' || item.contestRole === 'MAIN_SECRETARY' ||
								item.contestRole === 'LEADER' || item.contestRole === 'MAIN_LEADER');
						}
					},
					{name: "deleteUser", icon: "delete", label: "Usuń z komisji"},

				],
				contestInfo: {
					contestStatus: undefined,
					// announced: undefined,
					evaluationOpen: undefined,
				},
			};
		},
	};
</script>

<style scoped>
	.v-toolbar[data-booted="true"] {
		margin-top: 20px !important;
	}
</style>
